import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../api';
import EstimateDetailView from '../components/portal/EstimateDetailView';
import PublicBrandHeader from '../components/public/PublicBrandHeader';
import PublicBrandShell from '../components/public/PublicBrandShell';

export default function PublicEstimate() {
  const { token } = useParams();
  const [brand, setBrand] = useState(null);

  const fetchEstimate = useCallback(async () => {
    const res = await fetch(`${API_BASE_URL}public/estimates/${token}`, {
      headers: { Accept: 'application/json' },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(json?.message || json?.error || `HTTP ${res.status}`);
    }
    if (json.brand) setBrand(json.brand);
    return json;
  }, [token]);

  const postAction = useCallback(
    async (action) => {
      const res = await fetch(`${API_BASE_URL}public/estimates/${token}/${action}`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(json?.message || json?.error || `HTTP ${res.status}`);
      }
      return json;
    },
    [token]
  );

  return (
    <PublicBrandShell embeddedBrand={brand}>
      <Box sx={{ display: 'flex', justifyContent: 'center', p: { xs: 2, sm: 3 } }}>
        <Box sx={{ width: '100%', maxWidth: 900 }}>
          <PublicBrandHeader subtitle="View and respond to this estimate" />
          <EstimateDetailView fetchEstimate={fetchEstimate} postAction={postAction} />
        </Box>
      </Box>
    </PublicBrandShell>
  );
}
